import React from "react";
import LoginForm from "../../views/auth/LoginForm";
import { AuthProvider } from "../Context";
import { createBrowserHistory } from "history";

export const customHistory = createBrowserHistory();

function AuthLayout() {

    return (
        <AuthProvider>
            <LoginForm />
        </AuthProvider>
    );
}

export default AuthLayout;
